// closure for scope
(function($) {
    var ButtonState = {
        DOWNLOAD : 0,
        UPLOAD : 1,
        CANCEL : 2,
        APPLY : 3,
        DONE : 4
    };
    
    var $togglesWrapper = null;
    var $tabHighlighter = null;
    var $tabContentsWrapper = null;

    var webProducts = {
        "name" : "Compuware Web Products",
        "products" : [],
        "web" : true
    };
    
    var availableUpdates = null;
    var newestInstalledTopaz = null;
    
    // Download fields
    var webFileDownloadProgress = null;
    var topazDownloadProgress = null;
    
    // Upload fields
    var webFileUploader = null;
    var webFileUploadProgress = null;
    var topazUploader = null;
    var topazUploadProgress = null;
    
    var dbUpgradeRequired = false;
    var pingTimeout = null;
    var that = this;
    
    //***** ***** Class for updating a progress bar ***** *****//
    function ProgressUpdater(progressWrapper, url, type) {
        this.type = type || 'web';
        this.container = progressWrapper;
        this.percentDone = 0;
        this.interval = null;
        this.url = url;

        this.iterator = function() {
            if (!!this.url) {
                var progress = maintenanceUtils.getData('ws/update?url=' + url);
                
                progress.done(function(data) {
                    if (!!data && !!data.progress && data.progress > this.percentDone) {
                        this.percentDone = data.progress;
                        
                        if (data.state === 'COMPLETED') {
                            this.percentDone = 100;
                        }
                        
                        $.updateProgressBar(this.percentDone, this.container);
                    }
                }.bind(this));
            } else {
                var progress = maintenanceUtils.getData('maintenance/getPercentDone' + '?type=' + type);
                
                progress.done(function(data) {
                    if (data.success && data.percentDone > this.percentDone) {
                        this.percentDone = data.percentDone;
                        $.updateProgressBar(this.percentDone, this.container);
                    }
                }.bind(this));
            }
        }.bind(this);
        
        this.start = function() {
            this.interval = setInterval(this.iterator, 1000);
        }.bind(this);
        
        this.stop = function() {
            if (!!this.interval) {
                clearInterval(this.interval);
            }
        }.bind(this);
    };
    
    var pollServer = function(timeout) {
        var serverWasDown = false;
        var timeoutWasReset = false;
        var dbUpgradeInterval;
        
        // ping the server every 5 seconds
        var pingInterval = setInterval(function() {
            $.when(
                maintenanceUtils.getData('maintenance/ping')
            ).done(function(response) {
                // if the server was down previously, and is now back up, we're good
                if (serverWasDown) {  
                    $.debugLog('request succeeded after restart');
                    clearInterval(pingInterval);
                    clearTimeout(pingTimeout);
                    
                    if (dbUpgradeRequired == false) {
                        $.debugLog('restart not required, showing success message');
                        $.showSuccessStatus(com.compuware.ces.restartDone);
                        hideUpgradingIndicator();
                    } else {
                        $.debugLog('restart is required, upgrading database.');
                        hideUpgradingIndicator();
                        $.displayProgressBar(com.compuware.ces.progressTitle, com.compuware.ces.dbUpgrade);
                        
                        dbUpgradeInterval = setInterval(function(){
                			var progress = $.getJSON('database/getPercentDone',
               					{
               						nocache: new Date().getTime()
               					}
               				);

                			progress.done(function(data){
                				if (data.success == true){
                					$.updateProgressBar(data.percentDone);
                				}
                			});
                    	}, 1000);
                        
                        
                        $.when(
                            maintenanceUtils.getData('database/maintenanceUpgrade')
                        ).done(function(response) {
                            if (response.success == false) {
                            	var errorMessage = com.compuware.ces.dbUpgradeError;
                            	if(!!response.message && !!response.info) {
                            		errorMessage = response.message + ' ' + response.info;
                            	} else if(!!response.message) {
                            		errorMessage = response.message;
                            	}
                            	$.showErrorStatus(errorMessage);
                            } else {
                                $.showSuccessStatus(response.message);
                            }
                        }).fail(function(response) {
                            $.debugLog('unexpected error calling database delegate');
                            $.showErrorStatus(com.compuware.ces.dbUpgradeError);
                        }).always(function() {
                            clearInterval(dbUpgradeInterval);
                            $.removeProgressBar();
                        });
                    }
                }               
            }).fail(function(response) {
                $.debugLog('ping failed...');

                // when ping fails, set the down status
                if (!serverWasDown) {
                    $.debugLog('service has stopped responding...');
                    serverWasDown = true;
                }
                
                if (response.status == 404 && serverWasDown && !timeoutWasReset) {
                    timeoutWasReset = true;
                    clearTimeout(pingTimeout);
                    setPingTimeout(pingInterval, timeout);
                    $.debugLog('service has responded with error, extending timeout for OSGi grace period...');
                }
            });
        }, 5000);
        
        setPingTimeout(pingInterval, timeout);
    };
    
    var setPingTimeout = function(pingInterval, timeout){
        // after timeout minutes, we give up pinging
        pingTimeout = setTimeout(function(){
            $.debugLog('timeout reached, service has not responded');
            clearInterval(pingInterval);
            clearTimeout(that.pingTimeout);
            hideUpgradingIndicator();
            $.showMessageDialog({
                title: com.compuware.ces.uploadError, 
                message: com.compuware.ces.restartTimeout
            });
        }, 1000 * timeout);
    };
    
    var getTestingTimeout = function(){
        var queryString = location.search
        
        var matches = /\?.*timeout=(\d*)&?/i.exec(queryString);
        if (matches){
            return matches[1];
        }
    };      
    
    var showUpgradingIndicator = function() {
        $.displayLoadingIndicator(com.compuware.ces.upgradeProcessing);
        $('.animated-logo-underlay').addClass('fixed');
    };
    
    var hideUpgradingIndicator = function() {
        $.removeLoadingIndicator();
        $('.animated-logo-underlay').removeClass('fixed');        
    };
    
    var showTransferProgress = function(text, domContainer) {
        var progressWrapper = $(domContainer).find('.progress-wrapper');
        var actionButton = $(progressWrapper).siblings('button.product-button');
        var cancelButton = $(progressWrapper).siblings('button.cancel-apply');
        
        $.displayProgressBar('', text, null, null, null, progressWrapper);
        
        var progressBar = $(progressWrapper).find('.progress-bar-container');
        var containerWidth = $(domContainer).outerWidth() - $(actionButton).outerWidth() - $(cancelButton).outerWidth() - 20;
        
        $(progressWrapper).animate({width : containerWidth}, 500, function() {
            var progressText = $(progressBar).find('.progress-text');
            
            $(progressText).css({
                'width' : $(progressBar).width()
            });
            
            $(progressText).animate({opacity : 1}, 250);
        });
        
        changeButtonState(actionButton, ButtonState.CANCEL);
        
        return progressWrapper;
    };
    
    var hideTransferProgress = function(container, state) {
        var $manualCard = $(container).parents('.manual.card');
        
        if ($manualCard.length > 0) {
            var $whatsNewToggle = $manualCard.find('.product-details-toggle');
            
            $whatsNewToggle.hide();
            $manualCard.find('.product-details-wrapper').html('');
        }
        
        $(container).parents('.actions-wrapper').find('.database-upgrade-message').remove();
        changeButtonState($(container).siblings('button.product-button'), state);
        
        $(container).animate({width : '0'}, 500, function() {
            $.removeProgressBar(container);
        });
    };
    
    var changeButtonState = function(button, state) {
        var $cancelButton = $(button).siblings('.cancel-apply');
        var visibility = 'hidden';
        
        $(button).removeClass('cancel');
        $(button).removeClass('apply');
        $(button).removeClass('done');

        switch (state) {
            case (ButtonState.DOWNLOAD) :
                $(button).text(labelDownload);
                break;
            case (ButtonState.UPLOAD) :
                $(button).text(labelUpload);
                break;
            case (ButtonState.CANCEL) :
                $(button).addClass('cancel');
                $(button).text(cancelText);
                break;
            case (ButtonState.APPLY) :
                $(button).addClass('apply');
                $(button).text(labelApply);
                visibility = 'visible';
                break;
            case (ButtonState.DONE) :
                $(button).addClass('done');
                $(button).text(done);
                break;
        }
        
        $cancelButton.css({visibility : visibility});
    };
    
    const checkToggleUpdateAllowed = function() {
        const $progressWrappers = $('.progress-wrapper');
        for (var index = 0; index < $progressWrappers.length; index++) {
            let $wrapper = $($progressWrappers[index]);
            
            if ($('#checkForUpdatesToggle').is(':checked')) {
                if ($wrapper.html().length > 0) {
                    if ($wrapper.parent().hasClass('download-action-wrapper')) {
                        $.showErrorStatus(downloadInProgressMessage);
                    } else {
                        $.showErrorStatus(uploadInProgressMessage);
                    }
                    
                    return true;
                }
            } else {
            	return false;
            }        
        };
        
        return false;
    }
    
    const toggleUpdatesSection = function(event) {
        const toggleAllowed = checkToggleUpdateAllowed();
        
        if(!toggleAllowed) {
            if ($('#checkForUpdatesToggle').is(':checked')) {
                $('.manual.card').hide();
                $('.toggle-item.latest-versions').removeAttr('disabled');
                $('#showLatestVersionOnlyToggle').removeAttr('disabled');
                $('.checking-updates.card').fadeIn(500);
                getAvailableUpdates();
            } else {
            	$('.checking-updates.card').hide();
                $('.manual.card').fadeIn(500);
                $('.toggle-item.latest-versions').attr('disabled', 'disabled');
                $('#showLatestVersionOnlyToggle').attr('disabled', 'disabled');
                $('#onlineProductUpdates').hide();
                $('.disconnected.card').hide();
            }
        }      
    };

    var toggleDetails = function() {
        var $this = $(this);
        var $details = $this.parents('.product-info').siblings('.product-details-wrapper');
        var text = $this.text();
        
        if (text === showDetails) {
            $this.text(hideDetails);
            $details.slideDown(250);
        } else {
            $this.text(showDetails);
            $details.slideUp(250);
        }
    };
    
    var toggleAvailableElements = function() {
        if (!!availableUpdates) {
            for (property in availableUpdates) {
                var update = availableUpdates[property];
                
                if (update.product === 'Compuware Web Products') {
                    $('#webUpdatesButton').show();
                    break;
                }
            }
            
            $('.checking-updates.card').hide();
            $('.disconnected').hide();
        } else {
            $('#webUpdatesButton').hide();

            if ($('.tab .fa-refresh').hasClass('fa-spin')) {
                $('.disconnected').hide();
                $('.checking-updates.card').fadeIn(500);
            } else {
                $('.checking-updates.card').hide();
                
                if ($('#checkForUpdatesToggle').is(':checked')) {
                    $('.disconnected').fadeIn(500);
                }
            }
        }
    };
    
    const syncCheckForUpdatesOnlineToggle = function() {
        $.when(
            $.getJSON('ws/Config/checkForOnlineUpdates')
        ).done(function(response){
        	$('#checkForUpdatesToggle').prop("checked", response);
        }).fail(function(error) {
        	$.showErrorStatus(error.statusText);
        }).always(function(){
        	toggleUpdatesSection();
        });
    }
    
    var setCheckForUpdatesOnlineProperty = function() {
    	var checkForUpdatesOnlineToggle = $('#checkForUpdatesToggle').prop("checked");
    	$.when(
    		$.ajax({
		    	type: 'POST',
		    	url : "ws/Config/checkForOnlineUpdates",
		    	contentType : 'application/json',
		    	dataType : 'json',
		    	data : checkForUpdatesOnlineToggle.toString(),
		    	cache : false,
		    	nocache: new Date().getTime()
    		})
    	).fail(function(error) {
        	var errorTxt = '';
        	if(typeof error.responseJSON === 'undefined' ){
        		errorTxt = error.statusText
        	} else{
        		errorTxt = error.responseJSON.message
        	}
            $.showErrorStatus(errorTxt);
    	});
    }
    
    var sortUpdates = function(oldUpdate, newUpdate) {
        var oldVersion = parseInt(oldUpdate.version.replace(/\./g, ''));
        var newVersion = parseInt(newUpdate.version.replace(/\./g, ''));
        
        return newVersion - oldVersion;
    };
    
    var displayInstalledTopazRepos = function(installedTopazRepos) {
        var template = $('#installedTilesTemplate').html();
        var data = {"installedProducts" : installedTopazRepos};
        var html = Mustache.to_html(template, data);
        $('#installedTopazProducts').html(html);
        $('#installedTopazProducts .product-details-toggle').on('click', 'span', toggleDetails);
    }
    
    var displayInstalledProducts = function() {
        var template = $('#installedTilesTemplate').html();
        
        if (webProducts.products.length === 1) {
            webProducts.single = true;
        }
        
        var data = {"installedProducts" : webProducts};
        var html = Mustache.to_html(template, data);
        
        $('#installedProducts').html(html);
        $('#installedProducts .product-details-toggle').on('click', 'span', toggleDetails);
        toggleAvailableElements();
    }
    
    const displayUpdates = function() {
        const toggleAllowed = checkToggleUpdateAllowed();
        
        if (!toggleAllowed) {
            const template = $('#updateTilesTemplate').html();
            let updates = null;
            
            if (!!availableUpdates) {
                let webProductUpdates = [];
                let topazUpdates = [];
    
                for (property in availableUpdates) {
                    let update = availableUpdates[property];
                    
                    if (update.product === 'Compuware Web Products') {
                        webProductUpdates.push(update);
                    } else if (update.product === 'Topaz Workbench') {
                        topazUpdates.push(update);
                    }
                }
                
                webProductUpdates.sort(sortUpdates);
                topazUpdates.sort(sortUpdates);
    
                const filter = function(update, index) {
                    if (index != 0 && (update.state === 'DOWNLOADING' || update.state === 'PENDING' || update.state === 'PENDING_W_DB' || update.state === 'PROCESSING')){
                        $('#showLatestVersionOnlyToggle').prop( "checked", false );
                    }
                };
                
                webProductUpdates.forEach(filter);
                topazUpdates.forEach(filter);
                
                if ($('#showLatestVersionOnlyToggle').is(':checked')) {
                    updates = [];
                    
                    if (webProductUpdates.length > 0) {
                        updates.push(webProductUpdates[0]);
                    }
                    
                    if (topazUpdates.length > 0) {
                        let addUpdate = false;
    
                        if (!!topazUpdates[0].version) {
                            let versionArray = topazUpdates[0].version.split('.');
                            
                            if (isTopazNewer(versionArray, newestInstalledTopaz)) {
                                addUpdate = true;
                            }
                        }
                        
                        if (addUpdate) {
                            updates.push(topazUpdates[0]);
                        }
                    }
                } else {
                    updates = webProductUpdates.concat(topazUpdates);
                }
                
                if ($('#checkForUpdatesToggle').is(':checked')) { 
                    $('#onlineProductUpdates').fadeIn(500);
                    $('#onlineProductUpdates').html(Mustache.to_html(template, {updates : updates}));
                }
            }
            
            resumeActivities();
        }
    }
    
    // attempt to resume downloads or extractions in progress
    var resumeActivities = function() {
        var latestTopazVersion = 0;
        var latestWebVersion = 0;
        var active = [];
        
        for (var key in availableUpdates) {
            var update = availableUpdates[key];
            var $button = $('button[data-hash=\"' + update.md5Hash + '\"]');
            var $product = $button.parents('.update-product.card');
            var $actionsWrapper = $button.parents('.actions-wrapper');
            var $progressWrapper = $actionsWrapper.find('.progress-wrapper');
            if (update.state === 'DOWNLOADING' || update.state === 'PROCESSING' || update.state === 'DOWNLOADED'){
                if ($('button[data-hash=\"' + update.md5Hash + '\"]').length > 0){
                    downloadFile($button[0], true); //'resume' param here?
                } 
            } else if (update.state === 'PENDING' || update.state === 'PENDING_W_DB') {        
                $product.find('.update-steps li:first-child').addClass('completed');
                showTransferProgress(com.compuware.ces.downloadComplete, $actionsWrapper)
                $.updateProgressBar(100, $progressWrapper);
                changeButtonState($button, ButtonState.APPLY);
                
                if (update.state === 'PENDING_W_DB') {
                    showDatabaseUpgradeWarning($product);
                    showDatabaseUpgradeToggle();
                }
            }
        }
    };
    
    var showDatabaseUpgradeWarning = function(container) {
        $(container).find('.update-steps ol').after('<div class="database-upgrade-message"><i class="fa fa-exclamation-triangle"></i>' + dbUpgradeText + '</div>');
    };
    
    var showDatabaseUpgradeToggle = function() {
        $.getJSON('ws/Config/dbConnections').done(function(response) {
        	
        	try{
        		if(response['DBConnectionInfoResponse']['DBConnectionInfoList']['DBConnectionInfo'][0].dbType === 'ibmDB2zOS'){
                	$('#databaseUpgrade').show();        			
        		}
        	} catch(error){
        		$.debugLog('Cannot access database connection response');
        	}
        });
    }
    
    var setDatabaseUpgradeProperty = function() {
    	var databaseUpgradeToggle = !($('#databaseUpgradeToggle').prop("checked"));
    	$.when(
                $.ajax({
                    type: 'POST',
                    url : "ws/Config/doNotAutomaticallyUpgradeDatabase",
                    contentType : 'application/json',
                    dataType : 'json',
                    data : databaseUpgradeToggle.toString(),
                    cache : false,
                    nocache: new Date().getTime()
                })
            ).fail(function(error) {
            	var errorTxt = '';
            	if(typeof error.responseJSON === 'undefined' ){
            		errorTxt = error.statusText
            	} else{
            		errorTxt = error.responseJSON.message
            	}
                $.showErrorStatus(errorTxt);
                cancelApply();
            });
    }
    
    var isTopazNewer = function(versionOne, versionTwo) {
        var isNewer = false;
        
        if (!!versionTwo) {
            for (var index = 0; index < versionOne.length; index++) {
                var newNumber = parseInt(versionOne[index]);
                var currentNumber = parseInt(versionTwo[index]);
                
                if (newNumber > currentNumber) {
                    isNewer = true;  //the version is greater so it's the newest
                    break;
                }
                else if (newNumber < currentNumber) {
                    break; //the number is less so no need to continue
                }
            }
        } else {
            isNewer = true;
        }
        
        return isNewer;
    };
    
    // AJAX Requests to get information

    var getInstalledTopazRepos = function() {
        var topazRepos = [];
        newestInstalledTopaz = null;
        
        return maintenanceUtils.getData('topazrepos/getRepositoryList').done(function(response){
            if(!!response && response.success){
                $.debugLog(response);
                response.repos.forEach(function(repo) {
                    if (!!repo.version) {
                        var versionArray = repo.version.split('.');
                        
                        if (!!newestInstalledTopaz) {
                            if (isTopazNewer(versionArray, newestInstalledTopaz)) {
                                newestInstalledTopaz = versionArray;
                            }
                        } else {
                            newestInstalledTopaz = versionArray;
                        }
                    }
                    
                    topazRepos.push({
                        name : topazP2Site,
                        version : !!repo.version ? repo.version : '',
                        description : 'A blurb about Topaz Workbench',
                        repositoryLocation : repo.url,
                        repositoryName : repo.name
                    });
                });
            }
        }).always(function(){
            $.debugLog("Installed Topaz Repos:");
            $.debugLog(topazRepos);
            displayInstalledTopazRepos(topazRepos);
        });
    }
    
    var isInstalledProduct = function(productName) {
        var installed = false;
        
        if (!!webProducts.products) {
            for (var index = 0; index < webProducts.products.length; index++) {
                var product = webProducts.products[index];
                
                if (!!product && (product.name.toLowerCase() === productName.toLowerCase())) {
                    installed = true;
                    break;
                }
            }
        } 
        
        return installed;
    };
    
    //only display notes for products that are installed
    var filterNotes = function(notes) {
        var filteredNotes = [];
        
        for (var index = 0; index < notes.length; index++) {
            var note = notes[index];
            
            if (!!note) {
                if (!isInstalledProduct(note.name)) {
                    note.notInstalled = true;
                }
                
                filteredNotes.push(note);
            }
        }
        
        return filteredNotes;
    };
    
    //remove null or undefined entries
    var filterProducts = function(products) {
        var filteredProducts = [];
        
        for (var index = 0; index < products.length; index++) {
            var product = products[index];
            
            if (!!product) {
                filteredProducts.push(product);
            }
        }
        
        return filteredProducts;
    };
    
    var getInstalledProducts = function() {     
        webProducts.products = [];
        
        maintenanceUtils.getData('maintenance/getInstalledProducts').done(function(response){
            if(!!response && response.success) {
                var products = response.products;
                
                for (var index = 0; index < products.length; index++) {
                    var product = products[index];
                    var productDetails = {
                        name : product.name,
                        description : '',
                        version : product.version
                    };

                    if (product.name === 'Compuware Enterprise Services') {
                        webProducts.version = product.version.slice(0, product.version.lastIndexOf('.'));
                        productDetails.icon = 'img/Compuware_Icon_only.svg';
                        productDetails.description = cesDescription;
                    } else if (product.name === 'Abend-AID Fault Analytics') {
                        productDetails.icon = 'img/Operations_plain_marble.svg';
                        productDetails.description = faultAnalyticsDescription;
                    } else if (product.name === 'ISPW') {
                        productDetails.icon = 'img/Build_and_Deploy_plain_marble.svg';
                        productDetails.description = ispwDescription;
                    } else if (product.name === 'iStrobe') {
                        productDetails.icon = 'img/Operations_plain_marble.svg';
                        productDetails.description = iStrobeDescription;
                    } else if (product.name === 'Topaz for Java Performance' || product.name === 'Topaz For Java Performance') {
                        productDetails.icon = 'img/Operations_plain_marble.svg';
                        productDetails.description = tjpDescription;
                    } else if (product.name === 'Application Audit') {
	                    productDetails.icon = 'img/Cybersecurity_plain_marble.svg';
	                    productDetails.description = appAuditDescription;
                    } else if (product.name === 'ThruPut Manager') {
                        productDetails.icon = 'img/Operations_plain_marble.svg';
                        productDetails.description = thruputManagerDescription;
                    } else if (product.name === 'Topaz for Total Test') {
                    	productDetails.icon = 'img/development_icon.svg';
                    	productDetails.description = totalTestDescription;
                    } else {
                        productDetails.icon = 'img/Compuware_Icon_only.svg';
                        productDetails.description = '';
                    }
                    
                    webProducts.products.push(productDetails);
                }
                
                webProducts.products = filterProducts(webProducts.products);
            }
        }).always(function(){
            $.debugLog("Installed Products: ");
            $.debugLog(webProducts);
            displayInstalledProducts();
        });
    }
    
    var getLatestUpdatesVersions = function(updates) {
    	var latestUpdates = {};
    	for (var index = 0; index < updates.length; index++) {
    		if (!latestUpdates[updates[index].product]) {
    			latestUpdates[updates[index].product] = updates[index].version;
    			continue;
    		}
    		var currentUpdate = updates[index];
    		var latestUpdate = latestUpdates[currentUpdate.product];
    		
    		if (currentUpdate.version > latestUpdate) {
    			latestUpdates[updates[index].product] = currentUpdate.version;
    		}
    	}
    	return latestUpdates;
    }
    
    var getAvailableUpdates = function() {
        $('.tab .fa-refresh').addClass('fa-spin');
        
        $.when(
            $.getJSON('ws/update' + '?nocache=' + new Date().getTime())
        ).done(function(response) {
            if (!!response) {
                availableUpdates = {};
                
                if (!!response.updates) {
                    var updates = response.updates;
                    
                    if (!$.isArray(updates)) {
                        updates = [updates];
                    }
                    var latestUpdateVersions = getLatestUpdatesVersions(updates);
                    
                    for (var index = 0; index < updates.length; index++) {
                        var update = updates[index];
                        
                        if (update.product === 'Compuware Web Products') {
                            update.web = true;
                        }
                        
                        var date = new Date(update.releaseDate);
                        update.releaseDate = date.getUTCFullYear() + '-' + ('0' + (date.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + date.getUTCDate()).slice(-2);
                        
                        update.size = parseFloat(update.size).toFixed(2);
                        update.latest = latestUpdateVersions[update.product] === update.version;
                        if (!!update.notes) {
                            if (!$.isArray(update.notes)) {
                                update.notes = [update.notes];
                            }
    
                            for (var noteIndex = 0; noteIndex < update.notes.length; noteIndex++) {
                                var note = update.notes[noteIndex];
    
                                if (!!update.web) {
                                    if (note.name === 'Compuware Enterprise Services') {
                                        note.icon = 'img/Compuware_Icon_only.svg';
                                    } else if (note.name === 'Abend-AID Fault Analytics') {
                                        note.icon = 'img/Operations_plain_marble.svg';
                                    } else if (note.name === 'ISPW') {
                                        note.icon = 'img/Build_and_Deploy_plain_marble.svg';
                                    } else if (note.name === 'iStrobe') {
                                        note.icon = 'img/Operations_plain_marble.svg';
                                    } else if (note.name === 'Topaz for Java Performance' || note.name === 'Topaz For Java Performance') {
                                        note.icon = 'img/Operations_plain_marble.svg';
                                    } else if (note.name === 'Application Audit') {
                                    	note.icon = 'img/Cybersecurity_plain_marble.svg';
                                    } else if (note.name === 'ThruPut Manager') {
                                        note.icon = 'img/Operations_plain_marble.svg';
                                    }  else {
                                        note.icon = 'img/Compuware_Icon_only.svg';
                                    }
                                } else {
                                    if (note.name === 'File-Aid' || note.name === 'File-AID') {
                                        note.icon = 'img/File_AID_plain_marble_trimmed.svg';
                                    } else if (note.name === 'File-Aid EX' || note.name.indexOf('File-Aid EX') === 0 || note.name === 'File-AID EX' || note.name.indexOf('File-AID EX') === 0) {
                                        note.icon = 'img/File_AID_plain_marble_trimmed.svg';
                                    } else if (note.name === 'ISPW' || note.name.indexOf('ISPW') === 0) {
                                        note.icon = 'img/Build_and_Deploy_plain_marble.svg';
                                    } else if (note.name === 'Topaz for Total Test') {
                                        note.icon = 'img/development_icon.svg';
                                    } else if (note.name === 'Xpediter') {
                                        note.icon = 'img/Xpediter_plain_marble_trimmed.svg';
                                    } else if (note.name === 'Enterprise Data') {
                                        note.icon = 'img/data_icon.svg';
                                    } else {
                                        note.icon = 'img/development_icon.svg';
                                    }
                                }
                            }
                            
                            if (update.web === true) {
                                update.notes = filterNotes(update.notes);
                            }
                            
                            update.notes.sort(function(noteA, noteB) {
                               if (noteA.name === 'Compuware Enterprise Services') {
                                   return -1;
                               } else if (noteB.name === 'Compuware Enterprise Services') {
                                   return 1;
                               } else if (noteA.name < noteB.name) { 
                                   return -1;
                               } else if (noteA.name > noteB.name) {
                                   return 1;
                               } else {
                                   return 0;
                               }
                            });
                        }
                        
                        var versionArray = update.version.split('.');
                        update.version = versionArray[0] + '.' + versionArray[1] + '.' + versionArray[2];
                        availableUpdates[update.md5Hash] = update;
                    }
                }
            } else {
                availableUpdates = null;
            }
        }).fail(function(response) {
            var $disconnectedCard = $('#disconnectedCard');
            var $updatesToggle = $('#checkForUpdatesToggle');
            
            if (!!response && !!response.responseJSON && response.responseJSON.message === noHCIText) {
                $disconnectedCard.find('.name.text').html(noHCIText);
                $disconnectedCard.find('.description.text').html(noHCIDescription);
            } else if (!!response && !!response.responseJSON && response.responseJSON.message === directoryPermissionsText) {
                $disconnectedCard.find('.name.text').html(directoryPermissionsText);
                $disconnectedCard.find('.description.text').html(directoryPermissionsDescription);
                $updatesToggle.attr('disabled', 'disabled');
            } else {
                $disconnectedCard.find('.name.text').html(noConnectionText);
                $disconnectedCard.find('.description.text').html(noConnectionDescription);
            }
            
            availableUpdates = null;
        }).always(function() {
            $('.tab .fa-refresh').removeClass('fa-spin');
            toggleAvailableElements();
            displayUpdates();
        });
    };

    var removeTopazWorkbenchRepository = function(event) {
        var $removeButton = $(event.currentTarget);
        $.debugLog("Removing..." + $removeButton.data("name"));
        $.displayLoadingIndicator(deletingText);
        
        $.ajax({
            type: 'POST',
            url : 'topazrepos/deleteRepository',
            dataType : 'json',
            data : { reponames : $removeButton.data("name") },
            nocache: new Date().getTime(),
            cache : false
        }).done(function(response) {
            if (response.success === true) {
                $.debugLog("The Topaz repository was successfully deleted.");
                $removeButton.parents('.installed-product.card').remove();
                getInstalledTopazRepos().always(function() {
                    displayUpdates();
                });
            } else {
                $.debugLog("The Topaz repository could not be deleted.");
                $.showErrorStatus("The Topaz repository could not be deleted.");
            }
        }).always(function() {
            $.removeLoadingIndicator();
        });             
    };
    
    const initializeInstalledSection = function(){
        getInstalledProducts();
        getInstalledTopazRepos();
    }

    const initialize = function() {
        initializeInstalledSection();
        syncCheckForUpdatesOnlineToggle();
        setDatabaseUpgradeProperty();
        handleWindowResize();
    }
    
    //***** ***** Shared Download & Upload Methods ***** *****//
    var cancelApply = function(event, state) {
        $.displayLoadingIndicator(cancellingText);
        var $cancelApplyButton = $(event.currentTarget);
        var $actionButton = $cancelApplyButton.siblings('button.product-button');
        var $actionsWrapper = $cancelApplyButton.parents('.actions-wrapper');
        var progressWrapper = $actionsWrapper.find('.progress-wrapper');
        var ajaxOptions = {
            type : 'GET',
            url : 'maintenance/cleanUpFiles',
            dataType : 'json',
            cache : false,
            nocache: new Date().getTime()
        };
        
        event.stopPropagation();
        hideTransferProgress(progressWrapper, state);
        $actionsWrapper.find('.update-steps li').removeClass('completed');

        if (state === ButtonState.DOWNLOAD) {
            var md5Hash = $actionButton.data('hash');
            
            if (!!md5Hash && !!availableUpdates) {
                var updateInfo = availableUpdates[md5Hash];
            }
            
            ajaxOptions.type = 'DELETE';
            ajaxOptions.url = 'ws/update/cancelPending' + '?nocache=' + new Date().getTime();
            ajaxOptions.contentType = 'application/json';
            ajaxOptions.data = JSON.stringify(updateInfo);
        }
        
        $.ajax(ajaxOptions).done(function(response){
            $.showSuccessStatus(response.message)
        }).fail(function(response) {
            hideTransferProgress($progressWrapper, ButtonState.DOWNLOAD);
            $.showErrorStatus(response.message)
        }).always(function() {
            stopWebFileDownloadProgress();
            $.removeLoadingIndicator();
        });
    };
    
    var applyUpdate = function(event, state) {
        var $actionButton = $(event.currentTarget);
        var $actionsWrapper = $actionButton.parents('.actions-wrapper')
        var progressWrapper = $actionButton.parents('.actions-wrapper').find('.progress-wrapper');
        var ajaxOptions = {
            type : 'GET',
            url : 'maintenance/startUpgrade',
            dataType : 'json',
            cache : false,
            nocache: new Date().getTime()
        };
        
        showUpgradingIndicator();
        hideTransferProgress(progressWrapper, state);
        $actionsWrapper.find('.update-steps li:nth-child(2)').addClass('completed');
        
        if (state === ButtonState.DOWNLOAD) {
            var md5Hash = $actionButton.data('hash');
            
            if (!!md5Hash && !!availableUpdates) {
                var updateInfo = availableUpdates[md5Hash];
            }

            ajaxOptions.type = 'POST';
            ajaxOptions.url = 'ws/update/apply' + '?nocache=' + new Date().getTime();
            ajaxOptions.contentType = 'application/json';
            ajaxOptions.data = JSON.stringify(updateInfo);
        }
        
        $.when(
            $.ajax(ajaxOptions)
        ).done(function(upgradeResponse) {
            if (!!upgradeResponse && !!upgradeResponse.success && (upgradeResponse.success === true || upgradeResponse.success === 'true')) {
                $('.animated-text').text(restartInProgress);
                
                $.when(
                    maintenanceUtils.getData('maintenance/restart')
                ).done(function(restartResponse) {
                    if (!!restartResponse && !!restartResponse.success) {
                        var timeout = getTestingTimeout() || 600;
                        pollServer(timeout);
                    } else {
                        $.showErrorStatus(com.compuware.ces.restartFailed);
                    }
                }).fail(function() {
                    hideUpgradingIndicator();
                }).always(function() {
                    $actionsWrapper.find('.update-steps li').removeClass('completed');                  
                });
            } else {
            	if (!!upgradeResponse && !!upgradeResponse.displayText) {
                    $.showErrorStatus(upgradeResponse.displayText);
            	} else {
                    $.showErrorStatus(com.compuware.ces.upgradeFailedMessage);
            	}
                hideUpgradingIndicator();
                $actionsWrapper.find('.update-steps li').removeClass('completed');
            }
        }).fail(function(error) {
            var response = error.responseJSON;
            $.showErrorStatus(response.message);
            hideUpgradingIndicator();
            $actionsWrapper.find('.update-steps li').removeClass('completed');       
        });
    };
    
    //***** ***** Download Methods ***** *****//
    var downloadFile = function(button, resume) {
        var $button = $(button);
        var $product = $button.parents('.update-product.card');
        var $actionsWrapper = $button.parents('.actions-wrapper');
        var $progressWrapper = $actionsWrapper.find('.progress-wrapper');
        var md5Hash = $button.data('hash');
        var downloadUrl = (!resume) ? 'ws/update/download?nocache=' + new Date().getTime()  : 'ws/update/download?resume=true&nocache=' + new Date().getTime();
        var extractTopazUrl = 'ws/update/extract/topaz?nocache=' + new Date().getTime();
        var extractWebUrl = 'ws/update/extract/web?nocache=' + new Date().getTime();
        
        if (!!md5Hash && !!availableUpdates) {
            var updateInfo = availableUpdates[md5Hash];           
            
            // if this isn't a resume, check that no updates are in progress before allowing one
            if (resume || ($product.hasClass('topaz') && !topazDownloadProgress) || (!$product.hasClass('topaz') && !webFileDownloadProgress)){
            	if (!!updateInfo) {
                    var url = updateInfo.url;

                    showTransferProgress('Downloading', $actionsWrapper);
                    
                    $.when(
                        $.ajax({
                            type: 'POST',
                            url : downloadUrl,
                            contentType : 'application/json',
                            dataType : 'json',
                            data : JSON.stringify(updateInfo),
                            cache : false,
                            nocache: new Date().getTime()
                        })
                    ).done(function(response) {
                        $.updateProgressBar(100, $progressWrapper);
                        
                        if ($product.hasClass('topaz')) {
                            //restart the progress for the extraction process
                            stopTopazDownloadProgress();
                            startTopazDownloadProgress($progressWrapper);
                            $progressWrapper.find('.progress-text').text(com.compuware.ces.processingDownloadMessage);
                            $.updateProgressBar(0, $progressWrapper);
                            
                            $.when(
                                $.ajax({
                                    type: 'POST',
                                    url : extractTopazUrl,
                                    contentType : 'application/json',
                                    dataType : 'json',
                                    data : JSON.stringify(updateInfo),
                                    cache : false,
                                    nocache: new Date().getTime()
                                })
                            ).done(function(response) {
                                $progressWrapper.find('.progress-text').text(com.compuware.ces.downloadComplete);
                                $.updateProgressBar(100, $progressWrapper);
                                changeButtonState($button, ButtonState.DONE);
                            }).fail(function(error) {
                                var response = error.responseJSON;
                                if (response.message === operationCancelled){
                                    $.showSuccessStatus(response.message);
                                } else {
                                    $.showErrorStatus(response.message);
                                }
                                hideTransferProgress($progressWrapper, ButtonState.DOWNLOAD);
                            }).always(function() {
                                stopTopazDownloadProgress();
                            });
                        } else {
                            //restart the progress for the extraction process
                            stopWebFileDownloadProgress();
                            startWebFileDownloadProgress($progressWrapper);
                            $progressWrapper.find('.progress-text').text(com.compuware.ces.processingDownloadMessage);
                            $.updateProgressBar(0, $progressWrapper);
                            
                            $.when(
                                $.ajax({
                                    type: 'POST',
                                    url : extractWebUrl,
                                    contentType : 'application/json',
                                    dataType : 'json',
                                    data : JSON.stringify(updateInfo),
                                    cache : false,
                                    nocache: new Date().getTime()
                                })
                            ).done(function(response) {
                                if (!!response && !!response.message && response.message === 'dbUpradeRequired') {
                                    showDatabaseUpgradeWarning($product);
                                    showDatabaseUpgradeToggle();
									dbUpgradeRequired = true;
                                }
                                
                                $product.find('.update-steps li:first-child').addClass('completed');
                                $progressWrapper.find('.progress-text').text(com.compuware.ces.downloadComplete);
                                $.updateProgressBar(100, $progressWrapper);
                                changeButtonState($button, ButtonState.APPLY);
                            }).fail(function(error) {
                                var response = error.responseJSON;
                                if (response.message === operationCancelled){
                                    $.showSuccessStatus(response.message);
                                } else {
                                    $.showErrorStatus(response.message);
                                }
                                hideTransferProgress($progressWrapper, ButtonState.DOWNLOAD);
                            }).always(function() {
                                stopWebFileDownloadProgress();
                            });
                        }
                    }).fail(function(error) {
                        var response = error.responseJSON;
                        if ($product.hasClass('topaz')) {
                            stopTopazDownloadProgress();
                        } else {
                            stopWebFileDownloadProgress();                        
                        }
                        if (response.message === downloadCancelled){
                            $.showSuccessStatus(response.message);
                        } else {
                            $.showErrorStatus(response.message);
                        }
                        hideTransferProgress($progressWrapper, ButtonState.DOWNLOAD);
                    });
                    
                    if ($product.hasClass('topaz')) {
                        startTopazDownloadProgress($progressWrapper, url);
                    } else {
                        startWebFileDownloadProgress($progressWrapper, url);
                    }
                }
            } else {
            	if ($product.hasClass('topaz')) {
                	$.showErrorStatus(topazInProgressText);

            	} else {
                	$.showErrorStatus(webInProgressText);
            	}
            }
        }
    };

    var startWebFileDownloadProgress = function(progressWrapper, url) {
        if (!webFileDownloadProgress) {
            webFileDownloadProgress = new ProgressUpdater(progressWrapper, url, 'web');
            webFileDownloadProgress.start();
        }
    };
    
    var stopWebFileDownloadProgress = function() {
        if (!!webFileDownloadProgress) {
            webFileDownloadProgress.stop();
            webFileDownloadProgress = null;
        }
    };
    
    var startTopazDownloadProgress = function(progressWrapper, url) {
        if (!topazDownloadProgress) {
            topazDownloadProgress = new ProgressUpdater(progressWrapper, url, 'topaz');
            topazDownloadProgress.start();
        }
    };
    
    var stopTopazDownloadProgress = function() {
        if (!!topazDownloadProgress) {
            topazDownloadProgress.stop();
            topazDownloadProgress = null;
        }
    };
    
    var downloadHandler = function(event) {
        var $actionButton = $(event.currentTarget);
        $.clearStatus();
        event.stopPropagation();
        if ($actionButton.hasClass('cancel')) {
            cancelDownloadHandler(event);
        } else if ($actionButton.hasClass('done')) {
            downloadDoneHandler(event);
        } else if ($actionButton.hasClass('apply')) {
            applyDownloadHandler(event);
        } else {
            downloadFile($actionButton, false);
        }
    };
    
    var cancelApplyDownload = function(event) {
        cancelApply(event, ButtonState.DOWNLOAD);
    };
    
    var cancelDownloadHandler = function(event) {
        $.displayLoadingIndicator(cancellingText);
        var $actionButton = $(event.currentTarget);
        var $product = $actionButton.parents('.update-product.card');
        var progressWrapper = $actionButton.parents('.actions-wrapper').find('.progress-wrapper');
        
        event.stopPropagation();

        if ($product.hasClass('topaz')) {
            stopTopazDownloadProgress();
            
            $.when(
                $.ajax({url : 'ws/update/cancel/topaz', type : 'DELETE', nocache: new Date().getTime()})
            ).done(function(response) {
            }).fail(function(response) {
            }).always(function() {
                $.removeLoadingIndicator();
            });
        } else {
            stopWebFileDownloadProgress();

            $.when(
                $.ajax({url : 'ws/update/cancel/web', type : 'DELETE', nocache: new Date().getTime()})
            ).done(function(response) {
            }).fail(function(response) {
            }).always(function() {
                $.removeLoadingIndicator();
            });
        }
        
        hideTransferProgress(progressWrapper, ButtonState.DOWNLOAD);
    };
    
    var downloadDoneHandler = function(event) {
        var $actionButton = $(event.currentTarget);
        var progressWrapper = $actionButton.parents('.actions-wrapper').find('.progress-wrapper');
        var $card = $actionButton.parents('.update-product.card.topaz');
        $card.slideUp(125);
        
        event.stopPropagation();
        hideTransferProgress(progressWrapper, ButtonState.DOWNLOAD);
    };
    
    var applyDownloadHandler = function(event) {
        applyUpdate(event, ButtonState.DOWNLOAD);
    };
    
    //***** ***** Upload Methods ***** *****//
    var uploadHandler = function(event) {
        var $actionButton = $(event.currentTarget);
        $.clearStatus();
        
        if ($actionButton.hasClass('cancel')) {
            cancelUploadHandler(event);
        } else if ($actionButton.hasClass('done')) {
            uploadDoneHandler(event);
        } else if ($actionButton.hasClass('apply')) {
            applyUploadHandler(event);
        } else {
            $actionButton.siblings('input').click();
        }
        event.stopPropagation();
    };
    
    var cancelApplyUpload = function(event) {
        cancelApply(event, ButtonState.UPLOAD);
    };
    
    var cancelUploadHandler = function(event) {
        $.displayLoadingIndicator(cancellingText);
        var $actionButton = $(event.currentTarget);
        var progressWrapper = $actionButton.parents('.actions-wrapper').find('.progress-wrapper');
        
        event.stopPropagation();

        if ($actionButton.siblings('#webProductsFileInput').length > 0) {
            stopWebFileUploadProgress();
            
            if (!!webFileUploader && !!webFileUploader.jqXHR) {
                webFileUploader.jqXHR.abort();
                $.removeLoadingIndicator();
            } else {
                $.when(
                    $.ajax({url : 'ws/update/cancel/web', type : 'DELETE', nocache: new Date().getTime()})
                ).done(function(response) {
                }).fail(function(response) {
                }).always(function() {
                    $.removeLoadingIndicator();
                });
            }
        } else {
            stopTopazUploadProgress();

            if (!!topazUploader && !!topazUploader.jqXHR) {
                topazUploader.jqXHR.abort();
                $.removeLoadingIndicator();
            } else {
                $.when(
                    $.ajax({url : 'ws/update/cancel/topaz', type : 'DELETE', nocache: new Date().getTime()})
                ).done(function(response) {
                }).fail(function(response) {
                }).always(function() {
                    $.removeLoadingIndicator();
                });
            }
        }
        
        hideTransferProgress(progressWrapper, ButtonState.UPLOAD);
    };
    
    var uploadDoneHandler = function(event) {
        var $actionButton = $(event.currentTarget);
        var progressWrapper = $actionButton.parents('.actions-wrapper').find('.progress-wrapper');
        
        event.stopPropagation();

        if ($actionButton.parent().attr('for') === 'webProductsFileInput') {
            stopWebFileUploadProgress();
        } else {
            stopTopazUploadProgress();
        }
        
        hideTransferProgress(progressWrapper, ButtonState.UPLOAD);
    };
    
    var applyUploadHandler = function(event) {
        applyUpdate(event, ButtonState.UPLOAD);
    };
    
    var fileUploadComplete = function(isWeb) {
        var actionButton = $(this).parents('.actions-wrapper').find('button.product-button');
        var progressWrapper = $(this).parents('.actions-wrapper').find('.progress-wrapper');

        if (isWeb) {
            webFileUploadProgress.percentDone = 100;
            stopWebFileUploadProgress();
            
        } else {
            topazUploadProgress.percentDone = 100;
            stopTopazUploadProgress();
        }
        
        $.updateProgressBar(100, progressWrapper);
        $(progressWrapper).find('.progress-text').text(com.compuware.ces.uploadComplete);
        changeButtonState(actionButton, ButtonState.DONE);
        $.debugLog('Upload successful...');
    };
    
    var fileUploadProgress = function(event, data, isWeb) {
        var progressWrapper = $(this).parents('.actions-wrapper').find('.progress-wrapper');
        var progress = parseInt(data.loaded / data.total * 100, 10);
        $.updateProgressBar(progress, progressWrapper);
        
        if (progress >= 100) {
            $.clearStatus();
            $.updateProgressBar(0, progressWrapper);
            $(progressWrapper).find('.progress-text').text(com.compuware.ces.repoProcessingMessage);
            
            if (isWeb) {
                startWebFileUploadProgress(progressWrapper);
            } else {
                startTopazUploadProgress(progressWrapper);                
            }
        }
    };
    
    var displayUploadFailedStatus = function(error) {
        if (error.statusText === "abort"){
            $.showSuccessStatus(uploadCancelled);
        } else {
            $.showErrorStatus(uploadFailed);
        }
    }
    
    var startWebFileUploadProgress = function(progressWrapper) {
        if (!webFileUploadProgress) {
            webFileUploadProgress = new ProgressUpdater(progressWrapper);
            webFileUploadProgress.start();
        }
    };
    
    var stopWebFileUploadProgress = function() {
        if (!!webFileUploadProgress) {
            webFileUploadProgress.stop();
            webFileUploadProgress = null;
        }
    };
    
    var uploadWebFileComplete = function() {
        fileUploadComplete.call(this, true);
    };
    
    var uploadWebFileProgress = function(event, data) {
        fileUploadProgress.call(this, event, data, true);
    };
    
    var uploadWebFile = function(fileName, domContainer, data) {
        $.debugLog('Starting Web Products repository upload...');
        var progressWrapper = showTransferProgress(com.compuware.ces.uploadingDetails + fileName, domContainer);
        webFileUploader = data;
        
        data.submit().done(function(response) {
            $.debugLog(response);
           
            if (!response.success){
                $.showErrorStatus(response.message + " " + response.error);
                stopWebFileUploadProgress();
                hideTransferProgress(progressWrapper, ButtonState.UPLOAD);
            } else {
                var $updateSteps = $(domContainer).find('.update-steps');
                $updateSteps.find('li:first-child').addClass('completed');
                changeButtonState($(progressWrapper).siblings('button.product-button'), ButtonState.APPLY);
                
                if (!!response.dbupgrade) {
                	dbUpgradeRequired = true;
                    showDatabaseUpgradeWarning(domContainer);
                    showDatabaseUpgradeToggle();
                }
            }
        }).fail(function(error) {
        	displayUploadFailedStatus(error);
            hideTransferProgress(progressWrapper);
        });
        
        
    };

    var startTopazUploadProgress = function(progressWrapper) {
        if (!topazUploadProgress) {
            topazUploadProgress = new ProgressUpdater(progressWrapper, null, 'topaz');
            topazUploadProgress.start();
        }
    };
    
    var stopTopazUploadProgress = function() {
        if (!!topazUploadProgress) {
            topazUploadProgress.stop();
            topazUploadProgress = null;
        }
    };
    
    var uploadTopazFileComplete = function() {
        fileUploadComplete.call(this, false);
    };
    
    var uploadTopazFileProgress = function(event, data) {
        fileUploadProgress.call(this, event, data, false);
    };
    
    var checkTopazFileAlreadyExists = function(fileName) {
		return $.getJSON(baseCesURL + 'topazrepos/checkRepositoryExistance' + '?tempFileName=' + fileName, { nocache: new Date().getTime() }
    	);
    }
    
    var uploadTopazFile = function(fileName, domContainer, data) {
    	$.debugLog('Starting Topaz Workbench repository upload...');
        $.when(checkTopazFileAlreadyExists(fileName)).done(function(response){
        	if(response.repositoryExists) {
        		$.debugLog('Topaz repository upload failed: duplicate file exists');
        		$.showErrorStatus(topazRepoAlreadyExistsError);
        	} else {
        		var progressWrapper = showTransferProgress(com.compuware.ces.uploadingDetails + fileName, domContainer);
                topazUploader = data;
                
                data.submit().done(function(response) {
                    $.debugLog(response);
                   
                    if (!response.success){
                        $.showErrorStatus(response.message + ' ' + response.error);
                        stopTopazUploadProgress();
                        hideTransferProgress(progressWrapper, ButtonState.UPLOAD);
                    }
                }).fail(function(error) {
                	displayUploadFailedStatus(error);
                    hideTransferProgress(progressWrapper, ButtonState.UPLOAD);
                });
        	}
        })
    };
    
    var addUploadFile = function(event, data) {
        var fileName = maintenanceUtils.getFileName(data.fileInput.val());
        $.debugLog('File added: ' + fileName + '...');              
        
        if (!maintenanceUtils.validateFileExtension(fileName)) {
            $.showErrorStatus(com.compuware.ces.invalidFile);
        } else {
            $.clearStatus();
            $.showWarningStatus(uploadWarning);
            
            if ($(event.target).attr('id') === 'webProductsFileInput') {
                uploadWebFile(fileName, $(this).parents('.actions-wrapper'), data)
            } else {
                uploadTopazFile(fileName, $(this).parents('.actions-wrapper'), data)
            }
        }
    };

    var handleTabClicked = function(event) {
        var $target = $(event.delegateTarget);
        
        if (!$target.hasClass('selected')) {
            $('.tab.selected').removeClass('selected');
            $target.addClass('selected');
            
            if (!$('#checkForUpdatesToggle').is(':checked')) {
                $('.disconnected.card').hide();
            }
            
            if ($target.attr('id') === 'installedTab') {
                initializeInstalledSection();
                $togglesWrapper.fadeOut(500);
                $tabHighlighter.animate({left: '0px'}, 500);
                $tabContentsWrapper.animate({left: '0px'}, 500);
            } else {
                $togglesWrapper.fadeIn(500);
                $tabHighlighter.animate({left: '154px'}, 500);
                $tabContentsWrapper.animate({left: '-100%'}, 500);
            }

        }
    };
    
    var handleWindowResize = function() {
        var toggleHeight = 0;
        
        if ($(window).outerWidth() < 850) {
            $('#togglesWrapper').addClass('small');
            toggleHeight = 47;
        } else {
            $('#togglesWrapper').removeClass('small');
        }
        
        var adjustedHeight = $(window).outerHeight() - $('header').outerHeight() - $('.tabs-container').outerHeight();
        $('#installedTabContents').height(adjustedHeight);
        $('#updatesTabContents').height(adjustedHeight - toggleHeight);
    };
    
    var openLinkInNewTab = function(event) {
        window.open($(event.currentTarget).attr('href'), '_blank');
        event.preventDefault();
    };
    
    $(document).ready(function() {
        $togglesWrapper = $('#togglesWrapper');
        $tabHighlighter = $('#tabHighlighter');
        $tabContentsWrapper = $('#tabContentsWrapper');
        
        initialize();   
        
        $(window).resize(handleWindowResize);
        $('.tab').click(handleTabClicked);
        $('html').on('click', function(event) {
            $.clearStatus();
        });       

        $('#showLatestVersionOnlyToggle').click(displayUpdates);
        $('#checkForUpdatesToggle').click(toggleUpdatesSection);
        $('#installedProducts').on('click', '#webUpdatesButton', function(event) {
            $('#updatesTab').trigger("click");
        });
        
        // Installed tab product event handlers
        $('#installedTopazProducts').on('click', '.repository-info a', openLinkInNewTab);
        $('#installedTopazProducts').on('click', '.actions-wrapper button.remove-button', removeTopazWorkbenchRepository);
        
        // Updates tab product event handlers
        $('#onlineProductUpdates').on('click', '.release-notes-link', openLinkInNewTab);
        
        // Download event handlers
        $('#updatesTabContents').on('click', '.update-product.card .download-action-wrapper button.product-button', downloadHandler);
        $('#updatesTabContents').on('click', '.update-product.card .download-action-wrapper button.cancel-apply', cancelApplyDownload);

        // Upload event handlers
        $('#webProductsFileInput').fileupload({
            url: 'maintenance/uploadMaintenanceFile',
            dataType: 'json',
            add: addUploadFile,
            done: uploadWebFileComplete,
            progressall: uploadWebFileProgress
        });
        
        $('#topazFileInput').fileupload({
            url: 'topazrepos/uploadRepositoryFile',
            dataType: 'json',
            add: addUploadFile,
            done: uploadTopazFileComplete,
            progressall: uploadTopazFileProgress
        });
        
        $('#updatesTabContents').on('click', '.card.manual button.product-button', uploadHandler);
        $('#updatesTabContents').on('click', '.card.manual button.cancel-apply', cancelApplyUpload);
        $('#checkForUpdatesToggle').on('click', setCheckForUpdatesOnlineProperty);
        $('#databaseUpgradeLabel').on('click', setDatabaseUpgradeProperty);        
    });

})(jQuery);